<header class="container-fluid header landingpage">
    <div class="container header-bottom-area">
        <div>
            <div class="row align-items-center">
                <div class="col-12">
                    <!-- <div class="col-lg-3 col-md-6 col-6"> -->
                    <!-- </div> -->
                    <!-- <div class="col-lg-9 d-none d-lg-block"> -->
                    <!-- <div class="menu-area d-flex align-items-center justify-content-end"> -->
                    <nav class="navbar navbar-expand-lg position-relative row align-items-center px-0"
                        id="navbar-desktop-nav">
                        <div class="col-md-3 col-xs-6">
                            <div class="logo">
                                <a href="index.html">
                                    <img class="bluelogo" src="assets/images/logo/cropped-logo-2.png" alt="logo">
                                    <img class="whitelogo" src="assets/images/logo/whitelogo.png" alt="logo">
                                </a>
                            </div>
                        </div>
                        <div class="col-md-9 col-xs-6 position-unset">
                            <button class="navbar-toggler pull-right p-0 font-24px" type="button"
                                (click)="showHideNavbarMobile('show')">
                                <a class="coloredmenu"><i class="zmdi zmdi-menu"></i></a>
                                <a class="whitemenu"><i class="zmdi zmdi-menu"></i></a>
                            </button>
                            <div class="collapse navbar-collapse" id="navbar-desktop">
                                <ul class="navbar-nav mr-auto">
                                    <li class="nav-item dropdown megamenu-li">
                                        <a class="nav-link dropdowntoggle dropbtn" href="javascript://" id="product-for-corporates">Product
                                            for Corporates</a>
                                        <ul class="dropdownMenu megamenu megaparent"
                                            aria-labelledby="product-for-corporates">
                                            <div class="row">
                                                <div class="col-sm-6 col-lg-3">
                                                    <img src="assets/images/header/megamenu-image.webp"
                                                        alt="megamenu image" style="width: 100%;margin-top: 35%;">
                                                </div>
                                                <div class="col-sm-6 col-lg-3">
                                                    <div class="p-1">
                                                        <h3 class="font-17px d-flex-min-50">Mobile App Security</h3>
                                                        <hr>
                                                    </div>
                                                    <a class="dropdown-item my-2" routerLink="/appprotectt">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/appprotectt.webp"
                                                                alt="appprotectt" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">AppProtectt</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            Mobile App RunTime Security Platform (XDR)
                                                        </p>
                                                    </a>
                                                    <a class="dropdown-item my-2" routerLink="/codeprotectt">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/codeprotectt.webp"
                                                                alt="codeprotectt" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">CodeProtectt</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            Obfuscate your Mobile App Codes
                                                        </p>
                                                    </a>                                                   
                                                    <a class="dropdown-item my-2" routerLink="/appprotectt-lite">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/appprotectt-lite.webp"
                                                                alt="appprotectt lite" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">AppProtectt Lite</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            In-App Mobile App Security 
                                                        </p>
                                                    </a>
                                                    <a class="dropdown-item my-2" routerLink="/appbind">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/appbind.webp"
                                                                alt="appbind" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">AppBind</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            Zero Trust DEVICE & SIM Binding Solution  
                                                        </p>
                                                    </a>
                                                </div>
                                                <div class="col-sm-6 col-lg-3">
                                                    <div class="p-1">
                                                        <h3 class="font-17px d-flex-min-50">Mobile Device Security</h3>
                                                        <hr>
                                                    </div>
                                                    <a class="dropdown-item my-2" routerLink="/mprotectt-biz-plus">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/mprotectt-biz+.webp"
                                                                alt="mprotectt-biz" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">MProtectt Biz+</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            Advance Mobile Device Security for Enterprises
                                                        </p>
                                                    </a>
                                                    <div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div>
                                                </div>
                                                <div class="col-sm-6 col-lg-3">
                                                    <div class="p-1">
                                                        <h3 class="font-17px d-flex-min-50">Mobile Transaction Security</h3>
                                                        <hr>
                                                    </div>
                                                    <a class="dropdown-item my-2" routerLink="/realtime-protectt">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/realtime-protectt.webp"
                                                                alt="realtime-protectt" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">RealTime Protectt</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            RealTime Fraud & Risk Management Solution for Mobile Transactions
                                                        </p>
                                                    </a>
                                                    <div class="p-1">
                                                        <h3 class="font-17px">Platform</h3>
                                                        <hr>
                                                    </div>
                                                    <a class="dropdown-item my-2" routerLink="/platform">
                                                        <div class="d-flex align-items-center">
                                                            <img src="assets/images/header/platform.webp"
                                                                alt="platform" class="img-fluid width-25">
                                                            <h5 class="item-head mb-0">Platform</h5>
                                                        </div>
                                                        <p class="nav-link-descr">
                                                            Comprehensive Mobile Threat Defense Solution
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                        </ul>
                                    </li>
                                    <li class="nav-item dropdown megamenu-li">
                                        <a class="nav-link dropdowntoggle dropbtn" href="javascript://" id="product-for-individuals">Product
                                            for Individuals</a>
                                        <ul class="dropdownMenu megamenu customemega1 megaparent"
                                            aria-labelledby="product-for-individuals">
                                    <li class="py-1 item-headfornormal" routerLink="/mprotectt"><a>About Mobile Security</a></li>
                                    <li class="py-1 item-headfornormal" routerLink="mprotectt/android"><a>Android</a></li>
                                    <li class="py-1 item-headfornormal" routerLink="mprotectt/ios"><a style="text-transform: none;">iOS</a>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown megamenu-li">
                                <a class="nav-link dropdowntoggle dropbtn" href="javascript://" id="cyber-security-solution">Cyber
                                    Security Solution</a>
                                <ul class="dropdownMenu megamenu customemega2 megaparent"
                                    aria-labelledby="cyber-security-solution">
                            <li class="py-1 item-headfornormal" routerLink="/rasp"><a>Runtime Application Self Protection</a></li>
                            <li class="py-1 item-headfornormal" routerLink="/mobile-device-security"><a>Mobile Device Security</a></li>
                            <li class="py-1 item-headfornormal" routerLink="/rbi-digital-payment-security-control-solution"><a>Digital
                                    Payment Security Control</a>
                            </li>
                            <li class="py-1 item-headfornormal" routerLink="/frm"><a>Fraud & Risk Management</a></li>
                            <li class="py-1 item-headfornormal" routerLink="/byod"><a>Bring your own device</a></li>
                            <li class="py-1 item-headfornormal" routerLink="/cyber-lab-services"><a>Cyber Lab Services</a></li>
                        </ul>
                        </li>
                        <li class="nav-item dropdown megamenu-li">
                            <a class="nav-link dropdowntoggle dropbtn" href="javascript://" id="protectt-resouces">Resources</a>
                            <ul class="dropdownMenu megamenu customemega3 megaparent"
                                aria-labelledby="protectt-resouces">
                        <li class="py-1 item-headfornormal" routerLink="/blogs"><a>Blogs</a></li>
                        <li class="py-1 item-headfornormal" routerLink="/industry-news"><a>Industry News</a></li>
                        <li class="py-1 item-headfornormal" routerLink="/community"><a>Community</a></li>
                        <li class="py-1 item-headfornormal" routerLink="/ebrochure"><a>E-Brochure</a></li>
                        </ul>
                </li>
                <li class="nav-item dropdown megamenu-li">
                    <a class="nav-link dropdowntoggle dropbtn" href="javascript://" id="protectt-company">Company</a>
                    <ul class="dropdownMenu megamenu customemega4 megaparent" aria-labelledby="protectt-company">
                <li class="py-1 item-headfornormal" routerLink="/about-us"><a>About Us</a></li>
                <li class="py-1 item-headfornormal" routerLink="/leadership-team"><a>Leadership Team</a></li>
                <li class="py-1 item-headfornormal" routerLink="/customers"><a>Customers</a></li>
                <li class="py-1 item-headfornormal" routerLink="/partners"><a>Partners</a></li>
                <li class="py-1 item-headfornormal" routerLink="/media"><a>Media</a></li>
                <li class="py-1 item-headfornormal" routerLink="/careers"><a>Careers</a></li>
                    </ul>
            </li>
            </ul>
        </div>
    </div>
    </nav>
    <!-- </div> -->
    </div>
    </div>
    <nav class="navbar navbar-expand-lg" id="navbar-mobile-nav">
        <div class="row py-2">
            <div class="col-6">
                <img src="assets/images/logo/whitelogo.png" alt="whitelogo">
            </div>
            <div class="col-6">
                <button class="btn-navbar" (click)="showHideNavbarMobile('hide')">&times;</button>
            </div>
        </div>
        <div class="collapse navbar-collapse" id="navbar-mobile">
            <ul class="navbar-nav w-100">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle dropbtn lineheight30" href="javascript://" id="product-for-corporates" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">Product for
                        Corporates</a>
                    <div class="dropdown-menu pt-0" aria-labelledby="product-for-corporates">
                        <div class="row">
                            
                            <div class="col-12">
                                
                                    <h5 class="d-flex-min-50 p-1 text-light m-0">Mobile App Security</h5>
                                    <hr class="hrstyle "/> 
                                <a class="dropdown-item position-relative py-2" routerLink="/appprotectt">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/appprotectt_mobile.webp"
                                            alt="appprotectt mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">AppProtectt</h5>
                                    </div>
                                        <p class="nav-link-descr mb-0">
                                            Mobile App RunTime Security Platform (XDR)
                                        </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>
                                
                                <a class="dropdown-item position-relative py-2" routerLink="/codeprotectt">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/codeprotectt_mobile.webp"
                                            alt="codeprotectt mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">CodeProtectt</h5>
                                    </div>
                                        <p class="nav-link-descr mb-0">
                                            Obfuscate your Mobile App Codes
                                        </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>
                                <a class="dropdown-item position-relative py-2" routerLink="/appprotectt-lite">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/appprotectt-lite_mobile.webp"
                                            alt="ppprotectt-lite mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">AppProtectt Lite</h5>
                                    </div>
                                    <p class="nav-link-descr mb-0">
                                        In-App Mobile App Security 
                                    </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>
                                <a class="dropdown-item position-relative py-2" routerLink="/appbind">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/appbind_mobile.webp"
                                            alt="appbind mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">AppBind</h5>
                                    </div>
                                    <p class="nav-link-descr mb-0">
                                        Zero Trust DEVICE & SIM Binding Solution 
                                    </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>

                                <!-- <a class="dropdown-item position-relative py-2" routerLink="/mprotectt-biz-plus">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/mprotectt-biz+_mobile.webp"
                                            alt="mprotectt-biz+ mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">MProtectt Biz+</h5>
                                    </div>
                                    <p class="nav-link-descr mb-0">
                                            Advance Mobile Device Security for Enterprises
                                    </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>
                                <a class="dropdown-item position-relative py-2" routerLink="/realtime-protectt">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/realtime-protectt_mobile.webp"
                                            alt="realtime-protectt mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">RealTime Protectt</h5>
                                    </div>
                                    <p class="nav-link-descr mb-0">
                                            RealTime Fraud & Risk Management Solution for Mobile Transactions
                                    </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a>
                                <a class="dropdown-item position-relative py-2" routerLink="/platform">
                                    <div class="d-flex align-items-center">
                                        <img src="assets/images/header/platform_mobile.webp"
                                            alt="platform mobile" class="img-fluid width-25">
                                        <h5 class="item-head mb-0">Platform</h5>
                                    </div>
                                    <p class="nav-link-descr mb-0">
                                            Comprehensive Mobile Threat Defense Solution
                                    </p>
                                    <hr class="hrstyle full-width-hr"/>
                                </a> -->
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle dropbtn lineheight30" href="javascript://" id="product-for-individuals" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">Product for
                        Individuals</a>
                    <div class="dropdown-menu" aria-labelledby="product-for-individuals">
                        <div class="row">
                            <div class="col-12">
                                <a class="dropdown-item" routerLink="/mprotectt">
                                    <h5 class="item-head">About Mobile Security</h5>
                                </a>
                                <a class="dropdown-item" routerLink="mprotectt/android">
                                    <h5 class="item-head">Android</h5>
                                </a>
                                <a class="dropdown-item" routerLink="mprotectt/ios">
                                    <h5 class="item-head">iOS</h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle dropbtn lineheight30" href="javascript://" id="cyber-security-solution" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">Cyber Security
                        Solution</a>
                    <div class="dropdown-menu" aria-labelledby="cyber-security-solution">
                        <div class="row">
                            <div class="col-12">
                                <a class="dropdown-item" routerLink="/rasp">
                                    <h5 class="item-head">Runtime Application Self Protection</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/mobile-device-security">
                                    <h5 class="item-head">Mobile Device Security</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/rbi-digital-payment-security-control-solution">
                                    <h5 class="item-head">Digital Payment Security Control</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/frm">
                                    <h5 class="item-head">Fraud & Risk Management</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/byod">
                                    <h5 class="item-head">Bring your own device</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/cyber-lab-services">
                                    <h5 class="item-head">Cyber Lab Services</h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle dropbtn lineheight30" href="javascript://" id="protectt-resouces" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">Resources</a>
                    <div class="dropdown-menu" aria-labelledby="protectt-resouces">
                        <div class="row">
                            <div class="col-12">
                                <a class="dropdown-item" routerLink="/blogs">
                                    <h5 class="item-head">Blogs</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/industry-news">
                                    <h5 class="item-head">Industry News</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/community">
                                    <h5 class="item-head">Community</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/ebrochure">
                                    <h5 class="item-head">E-Brochure</h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle dropbtn lineheight30" href="javascript://" id="protectt-company" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">Company</a>
                    <div class="dropdown-menu" aria-labelledby="protectt-company">
                        <div class="row">
                            <div class="col-12">
                                <a class="dropdown-item" routerLink="/about-us">
                                    <h5 class="item-head">About Us</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/leadership-team">
                                    <h5 class="item-head">Leadership Team</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/customers">
                                    <h5 class="item-head">Customers</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/partners">
                                    <h5 class="item-head">Partners</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/media">
                                    <h5 class="item-head">Media</h5>
                                </a>
                                <a class="dropdown-item" routerLink="/careers">
                                    <h5 class="item-head">Careers</h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
    </div>
    </div>
</header>